'use client';

import { type FieldValues, FormProvider, type UseFormReturn } from 'react-hook-form';

type FormWrapperProps<T extends FieldValues> = {
  children: React.ReactNode;
  className?: string;
  dataTestId: string;
  formMethods: UseFormReturn<T>;
  id?: string;
  inert?: boolean;
  onSubmit: (data: T) => Promise<void> | void;
};

export const FormWrapper = <T extends FieldValues>({
  children,
  className,
  dataTestId,
  formMethods,
  id,
  inert,
  onSubmit,
}: FormWrapperProps<T>) => {
  return (
    <FormProvider {...formMethods}>
      <form
        className={className}
        data-testid={dataTestId}
        id={id}
        inert={inert}
        onSubmit={formMethods.handleSubmit(onSubmit)}
      >
        {children}
      </form>
    </FormProvider>
  );
};
